import { useDispatch, useSelector } from "react-redux"
import {
  clearSchoolCalendarSegmentsList,
  deleteSchoolCalendarSegment,
  getSchoolCalendarSegmentsList,
} from "../../../../../../../library/store/actions/creators/groupsCreators"
import SegmentsListItem from "./components/segmentsListItem/segmentsListItem"
import { useParams } from "react-router-dom"
import SegmentFormModal from "./components/segmentFormModal/segmentFormModal"
import ListPage from "../../../../../../../components/v2/layout/listPage/listPage"
import useCreator from "../../../../../../../hooks/useCreator"

const GroupSettingsCalendarClassSegments = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const creator = useCreator()

  const { segmentsList, segmentsListEndReached } = useSelector(
    ({ groups }) => groups
  )

  const onDeleteSegment = async (id) =>
    await creator(deleteSchoolCalendarSegment({ id }))

  return (
    <ListPage
      title={"Segments"}
      creationButtonTitle={"Create segment"}
      noResultsLabel={"This Calendar doesn't have segments yet"}
      getList={async ({ name, offset }) =>
        await dispatch(
          getSchoolCalendarSegmentsList({
            schedule_id: parseInt(params.calendarId, 10),
            name,
            offset,
          })
        )
      }
      clearList={() => dispatch(clearSchoolCalendarSegmentsList())}
      list={segmentsList}
      listEndReached={segmentsListEndReached}
      getListItemComponent={({ item, openEditDialog, openDeletionDialog }) => (
        <SegmentsListItem
          key={item.id}
          segment={item}
          openDeleteSegment={openDeletionDialog}
          openEditSegment={openEditDialog}
        />
      )}
      getFormDialogComponent={({ open, onClose, activeItem }) => {
        return (
          <SegmentFormModal
            activeSegment={activeItem}
            edit={!!activeItem}
            onClose={onClose}
            open={open}
          />
        )
      }}
      getDeletionDialogComponent={{
        entityName: "segment",
        onDelete: onDeleteSegment,
      }}
    />
  )
}

export default GroupSettingsCalendarClassSegments
